import { useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { AdCampaignWizard } from '@/components/mediaBuying/adCampaign/AdCampaignWizard'
import { CubeLoader } from '@/components/ui/cube-loader'
import { GET_AD_CAMPAIGN_FOR_EDIT } from '@/graphql/ads/ad-campaigns-queries'
import { useHypothesisLabels } from './utils/useHypothesisLabels'
import { buildAdCampaignEditWizardInitialState } from './utils/adCampaignEditWizardInitialState'

const EditAdCampaign = () => {
    const { adCampaignId } = useParams()

    const { data, loading, error } = useQuery(GET_AD_CAMPAIGN_FOR_EDIT, {
        variables: { adCampaignId },
        skip: !adCampaignId,
    })

    const { labels: hypothesisLabels, loading: labelsLoading } = useHypothesisLabels(
        data?.AdCampaign?.adCampaignForEdit?.ad_sets,
    )

    if (loading || labelsLoading) {
        return (
            <div className="tw:w-full tw:flex tw:items-center tw:justify-center tw:h-full">
                <CubeLoader size="default" fullScreen={true} />
            </div>
        )
    }

    if (error || !data?.AdCampaign?.adCampaignForEdit) {
        return (
            <div className="tw:w-full tw:flex tw:items-center tw:justify-center tw:h-full">
                <p className="tw:text-red-400">Failed to load campaign data.</p>
            </div>
        )
    }

    const campaignData = data.AdCampaign.adCampaignForEdit
    const wizardInitialState = buildAdCampaignEditWizardInitialState(campaignData, { hypothesisLabels })

    return (
        <AdCampaignWizard
            isEditMode
            adCampaignId={adCampaignId}
            editInitialState={wizardInitialState}
        />
    )
}

export default EditAdCampaign
